



























































import {Vue, Component} from 'vue-property-decorator';
import ValidateInput from '@/components/common/input/ValidateInput.vue';
import {popupResize} from '@/utils/ncp';

@Component({
  metaInfo() {
    return (this as any).viewTitle;
  },
  components: {ValidateInput}
})
export default class StockModify extends Vue {
  private type = 'adjust';
  private checkCount = 0;
  private get viewTitle() {
    return {
      title: this.pageTitle
    };
  }
  private get pageTitle() {
    if (this.type === 'adjust') {
      return this.$t('STOCK_MANAGEMENT_STOCK_MODIFY_TITLE_ADJUST') as string;
    } else {
      return this.$t('STOCK_MANAGEMENT_STOCK_MODIFY_TITLE_EDIT') as string;
    }
  }

  private inputErr = '';
  private stockCnt = '';
  private adjustOptions = {
    name: 'adjustCnt',
    type: 'text-num',
    max: 99999999,
    min: 0
  };
  private editOptions = {
    name: 'editCnt',
    type: 'negative-num',
    max: 99999999,
    min: -99999999
  };

  private save() {
    let resInfo: any = {
      stockCnt: this.stockCnt === '-' ? 0 : Number(this.stockCnt),
      type: this.type,
      confirmType: true
    };
    if (!localStorage.getItem('checkedRows')) {
      alert(this.$t('STOCK_MANAGEMENT_POP_AGAIN_MSG'));
      self.close();
    }
    if (!confirm(window.$t('STOCK_MANAGEMENT_STOCK_MODIFY_CONFIRM', [this.checkCount]))) {
      resInfo.confirmType = false;
    }

    let callBackName = sessionStorage.getItem('stockCallBackName');
    if (callBackName) {
      $(window.opener.location).attr('href', `javascript:window.${callBackName}(${JSON.stringify(resInfo)});`);
    }
    self.close();
  }

  private async mounted() {
    this.$nextTick(() => {
      popupResize(750);
    });
  }
  private created() {
    this.type = this.$route.query.type as string;
    this.checkCount = JSON.parse(localStorage.getItem('checkedRows')).length;
  }
}
